/**
 * 화면이 Revision 매핑 편집 상태를 잡는 자리. 수명은 화면이 아니라 모듈 슬롯이 든다(`mappingEditor.ts`).
 * episode 를 바꿔 점검 화면이 다시 서도 같은 Revision 이면 편집본이 남는다.
 */
import { useEffect, useSyncExternalStore } from "react";
import {
  acquireMappingEditor,
  type MappingEditor,
  type MappingEditorState,
} from "../feature/mappingEditor";

export type MappingEditorHandle = {
  readonly editor: MappingEditor;
  readonly state: MappingEditorState;
};

/**
 * `active` 인 동안 이 화면이 편집 상태를 본다(`watch`). 거짓이거나 화면을 떠나면 이 화면은 그만 보고, 보는 화면이
 * 남지 않으면 POC 폴링 · 서버 대조를 멈춘다. 편집본과 POC 기록은 남는다.
 */
export function useMappingEditor(
  revisionUuid: string | null,
  active: boolean,
  datasetUuid: string | null = null,
): MappingEditorHandle {
  const editor = acquireMappingEditor(revisionUuid, datasetUuid);
  const state = useSyncExternalStore(editor.subscribe, editor.getSnapshot);
  useEffect(() => (active ? editor.watch() : undefined), [editor, active]);
  return { editor, state };
}
